export default __webpack_public_path__ + "static/media/rating_1.f1d86e64.png";